import React, { Component } from "react";
// import './tableArticles.css';
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import FeatherIcon from "feather-icons-react";
import api from "../../../http/global-vars";
import axios from "axios";
import { toast } from "react-toastify";
import AddDeliveryModal from "./AddDeliveryModal";
import { formatMoney } from "../../../utils/utils";
import EditDeliveryModal from "./EditDeliveryModal";
import DeleteDeliveryModal from "./DeleteDeliveryModal";
import ShowDeliveryModal from "./ShowDeliveryModal";

export default class TableDelivery extends Component {
  constructor(props) {
    super(props);
    this.state = {
      deliveries: [],
      delivery: {},
      api: api,
      fields: {},
      loading: false,
      requestConfig: {
        headers: {
          Authorization: `Bearer ${window.localStorage.getItem("userToken")}`,
        },
      },
      show: false,
      showDetails: false,
      archivageInProgress: false,
    };
  }

  componentDidMount() {
    this.getDeliveries();
  }

  getDeliveries = () => {
    axios.get(`${api}delivery/`, this.state.requestConfig).then((response) => {
      this.setState({
        deliveries: response?.data?.results.sort((a, b) => b?.id - a?.id),
      });
    });
  };

  handleClose = (e) => {
    e.preventDefault();
    this.setState({ show: false });
    this.setState({
      delivery: {},
      archivageInProgress: false,
    });
  };
  handleOpen = (row) => {
    this.setState({
      delivery: row,
    });
    this.setState({ show: true });
  };

  handleCloseDetails = (e) => {
    e.preventDefault();
    this.setState({ showDetails: false });
    this.setState({
      delivery: {},
      archivageInProgress: false,
    });
  };
  handleOpenDetails = (row) => {
    this.setState({
      delivery: row,
    });
    this.setState({ showDetails: true });
  };

  onDeleteDelivery = (e) => {
    e.preventDefault();
    this.setState({ archivageInProgress: true });
    let { delivery } = this.state;

    axios
      .delete(`${api}delivery/${delivery?.id}/`, this.state.requestConfig)
      .then((response) => {
        console.log(response);
        // this.setState({ archivageInProgress: false });
        if (response) {
          // Alert.success("Le produit à été supprimé.");
          setTimeout(() => {
            // this.props.onGetProductShop();
          }, 3000);
          this.setState({
            delivery: {},
            archivageInProgress: false,
            show: false,
          });
          this.getDeliveries();
          toast.success("Mode de livraison supprimé avec succés.");
        }
      })
      .catch((error) => {
        if (error) {
          this.setState({ archivageInProgress: false });
        }
      });
  };

  priceFormatter = (cell, row) => {
    return formatMoney(cell);
  };

  actionFormatter = (cell, row) => {
    return (
      <div className="dis-flex justify-content-center">
        <button
          data-toggle="modal"
          onClick={() => this.handleOpenDetails(row)}
          className="btn-action-table-grey clear"
          title="Détails"
        >
          <FeatherIcon icon="eye" className="icon-action-table-grey" />
        </button>
        <button
          data-toggle="modal"
          data-target={`.edit-delivery-modal${row?.id}`}
          className="btn-action-table-grey clear"
          title="Modification"
        >
          <FeatherIcon icon="edit" className="icon-action-table-grey" />
        </button>
        <button
          title="Suppression"
          onClick={() => this.handleOpen(row)}
          className="btn-action-table-grey clear"
        >
          <FeatherIcon icon="trash-2" className="icon-action-table-grey" />
        </button>

        {/* MOdal Edit */}
        <div
          className={`modal fade easypm-modal edit-delivery-modal${row?.id}`}
          id="AddDeliveryMoal"
          tabIndex="-1"
          data-backdrop="static"
          aria-labelledby="AddDeliveryMoalLabel"
          aria-hidden="true"
        >
          <EditDeliveryModal
            delivery={row}
            getDeliveries={this.getDeliveries}
          />
        </div>
      </div>
    );
  };

  render() {
    const options = {
      noDataText: "Aucune donnée disponible",
    };
    return (
      <div>
        <div className="row mb-3">
          <div className="col-md-9 col-sm-8 mb-sm-0 mb-5">
            {/* <p className="title-filter-dashboard">Tous les produits</p> */}
          </div>
          <div className="col-md-3 col-sm-4 pl-sm-0">
            <div
              className="adding-item-container linkable"
              data-toggle="modal"
              data-target=".add-delivery-modal"
              style={{ justifyContent: "center" }}
            >
              <span className="icon-container">
                <FeatherIcon
                  icon="plus-circle"
                  className="icon-action-table-grey"
                />
              </span>
              <span className="adding-item-label">
                Ajouter un mode de livraison
              </span>
            </div>
          </div>
        </div>
        <div className="table-container">
          <BootstrapTable
            className="head-table-custom"
            options={options}
            data={this.state.deliveries}
            search={true}
            multiColumnSearch={true}
            striped
            hover
            multiColumnSort={2}
            pagination
            version="4"
          >
            <TableHeaderColumn
              isKey
              dataField="id"
              hidden={true}
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                whiteSpace: "normal",
                lineHeight: 1,
              }}
              thStyle={{ textAlign: "center" }}
              className="th-table-custom"
            >
              N°
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="name"
              width="230"
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                whiteSpace: "normal",
                lineHeight: 1,
              }}
              dataAlign="center"
              // thStyle={{ textAlign: "center" }}
              className="th-table-custom"
            >
              Nom
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="duration"
              className="th-table-custom"
              width="150"
              // thStyle={{ textAlign: "center" }}
              dataAlign="center"
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                // textAlign: "center",
              }}
            >
              Durée
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="amount"
              dataFormat={this.priceFormatter}
              className="th-table-custom"
              width="150"
              // thStyle={{ textAlign: "center" }}
              dataAlign="center"
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                // textAlign: "center",
              }}
            >
              Prix
            </TableHeaderColumn>
            <TableHeaderColumn
              className="th-table-custom"
              dataFormat={this.actionFormatter}
              dataField="id"
              width="150"
              dataAlign="center"
              // thStyle={{ textAlign: "center" }}
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                // textAlign: "center",
              }}
            >
              Actions
            </TableHeaderColumn>
          </BootstrapTable>
        </div>
        {/* MOdal Add */}
        <div
          className="modal fade easypm-modal add-delivery-modal"
          id="AddDeliveryMoal"
          tabIndex="-1"
          data-backdrop="static"
          aria-labelledby="AddDeliveryMoalLabel"
          aria-hidden="true"
        >
          <AddDeliveryModal getDeliveries={this.getDeliveries} />
        </div>
        <DeleteDeliveryModal
          handleClose={this.handleClose}
          show={this.state.show}
          onDeleteDelivery={this.onDeleteDelivery}
          archivageInProgress={this.state.archivageInProgress}
        />
        <ShowDeliveryModal
          handleCloseDetails={this.handleCloseDetails}
          showDetails={this.state.showDetails}
          delivery={this.state.delivery}
        />
      </div>
    );
  }
}
